import { lazy } from 'react'

import { Card } from '@procurify/ui'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const CreditCardAccountListViewChunk = lazy(() =>
  import('../feature-sets/CreditCardAccountListView').then(
    ({ CreditCardAccountListView }) => ({
      default: CreditCardAccountListView,
    })
  )
)

export const CreditCardReconciliationPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.creditCardReconciliationPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.creditCardReconciliationPageTitle),
        },
      ]}
    >
      <Card>
        <Card.Content>
          <CreditCardAccountListViewChunk />
        </Card.Content>
      </Card>
    </Page>
  )
}
